import { GlButton } from '@gitlab/ui';
import { TYPE_ISSUE } from '~/issues/constants';
import UncollapsedAssigneeList from './uncollapsed_assignee_list.vue';
export default {
    name: 'IssuableAssignees',
    components: {
        GlButton,
        UncollapsedAssigneeList
    },
    props: {
        users: {
            type: Array,
            required: true
        },
        issuableType: {
            type: String,
            required: false,
            default: TYPE_ISSUE
        },
        signedIn: {
            type: Boolean,
            required: false,
            default: false
        },
        editable: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'assign-self'
    ],
    computed: {
        emptyUsers () {
            return this.users.length === 0;
        }
    }
};
